export class PaymentProcess {
  code: string;
  id: number;
  
  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/PaymentProcess.ts